import styled, { css } from 'styled-components'

interface EllipseGroupContainerPositionProps {
  position: number
}

export const EllipseGroupContainerPosition = styled.button<EllipseGroupContainerPositionProps>`
  position: absolute;
  left: ${props => props.position}%;
  top: 50%;

  ${props =>
    props.position <= 50
      ? css`
          transform: translateY(-50%);
        `
      : css`
          transform: translate(-100%, -50%);
        `};
  border: none;
  border-radius: 50%;
`

interface BackEllipseContainerProps {
  indexEllipse: number
}

export const BackEllipseContainer = styled.div<BackEllipseContainerProps>`
  position: relative;
  margin-left: -37px; // ellipse size - ellipse margin
  z-index: -${props => props.indexEllipse};
`

export const GroupEllipsesContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover .background {
    filter: brightness(0.8);
  }
  &:focus {
    filter: drop-shadow(0px 0px 1px #000);
    outline: none;
  }
  &:hover {
    z-index: 1000;
  }
`
